var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-app"},[_c('DashboardHeader',{attrs:{"dashboard":_vm.dashboard,"store-prefix":_vm.storePrefix}}),_vm._v(" "),_c('DashboardContent',{attrs:{"dashboard":_vm.dashboard,"store-prefix":_vm.storePrefix}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }